import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|decisionId|optionId|ballotId|selectedOptionId|createdByMemberId|closedByMemberId|situationReferenceId|memberId|ownerMemberId|creatorMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey collaboration decisions — Collaboration Context only (no incident/IM UI). */
export const journeyDecisionApi = {
  list: (journeyId) => travelClient.get(
    travelEndpoints.journeyDecisions(journeyId),
    snowflakeJson,
  ),
  get: (journeyId, decisionId) => travelClient.get(
    travelEndpoints.journeyDecision(journeyId, decisionId),
    snowflakeJson,
  ),
  getResults: (journeyId, decisionId) => travelClient.get(
    travelEndpoints.journeyDecisionResults(journeyId, decisionId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyDecisions(journeyId),
    body,
    snowflakeJson,
  ),
  updateDraft: (journeyId, decisionId, body) => travelClient.patch(
    travelEndpoints.journeyDecision(journeyId, decisionId),
    body,
    snowflakeJson,
  ),
  open: (journeyId, decisionId, body) => travelClient.post(
    travelEndpoints.journeyDecisionOpen(journeyId, decisionId),
    body,
    snowflakeJson,
  ),
  vote: (journeyId, decisionId, body) => travelClient.post(
    travelEndpoints.journeyDecisionVotes(journeyId, decisionId),
    body,
    snowflakeJson,
  ),
  close: (journeyId, decisionId, body) => travelClient.post(
    travelEndpoints.journeyDecisionClose(journeyId, decisionId),
    body,
    snowflakeJson,
  ),
  cancel: (journeyId, decisionId, body) => travelClient.post(
    travelEndpoints.journeyDecisionCancel(journeyId, decisionId),
    body,
    snowflakeJson,
  ),
};
